<script lang="ts">
  import Media from '../media/Media.svelte';

  export let profileImage: string;
  export let userName: string = '';
  export let rounded: boolean = false;
  export let cls = 'w-12 h-12';
</script>

{#if !!profileImage}
  <Media
    {rounded}
    src={profileImage}
    alt="users avatar"
    class="{cls} rounded-full object-cover max-w-fit aspect-square scrollbar-hide"
  />
{:else}
  
  <img
    src="https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${userName}"
    class="size-12 {cls} rounded-full object-cover aspect-square"
    alt=""
  />

  <!-- 
  <Media
    {rounded}
    src={`https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${userName}`}
    alt="users avatar"
    class="{cls} rounded-full object-cover max-w-fit aspect-square scrollbar-hide"
  /> -->
{/if}
